/* eslint-disable react/jsx-props-no-spreading */
import { getComponentFromName } from '../../lib/utils';

import { useTheme } from '../../contexts/ThemeContext';
import * as GamesComponents from './games/index';

interface GameProps {
    game: Game;
    [key: string]: any;
}

function GameItem({ game, ...props }: GameProps) {
    const { name: theme = null, variant = null } = useTheme();
    const { type = null, theme: gameTheme } = game || {};
    const { itemComponent = null } = gameTheme || {};

    const GameComponent =
        getComponentFromName(GamesComponents, itemComponent) ||
        (variant || []).reduce(
            (acc, v) => acc || getComponentFromName(GamesComponents, v, null),
            null,
        ) ||
        getComponentFromName(GamesComponents, theme) ||
        getComponentFromName(GamesComponents, type, 'default') ||
        null;

    return GameComponent !== null ? <GameComponent game={game} {...props} /> : null;
}

export default GameItem;
